import React from 'react'
import { Formik, Form } from 'formik'
import {
  InputField,
  InputGroupField,
  UploadImageField,
  LoaderButton
} from 'components/molecules'
import cmsLuxurySectionEditScheme from './cms-luxury-section-edit-scheme'
import PropTypes from 'prop-types'

const propTypes = {
  section: PropTypes.shape({
    is_active        : PropTypes.bool,
    name             : PropTypes.string,
    order            : PropTypes.number,
    alt_text         : PropTypes.string,
    image_url        : PropTypes.string,
    mobile_image_url : PropTypes.string,
    header_text      : PropTypes.string,
    caption_text     : PropTypes.string,
    title_text       : PropTypes.string,
    seo_title        : PropTypes.string,
    url              : PropTypes.string
  }),
  image            : PropTypes.object,
  mobileImage      : PropTypes.object,
  setImage         : PropTypes.func,
  setMobileImage   : PropTypes.func,
  handleSubmitForm : PropTypes.func
}


const defaultProps = {
  section: {
    is_active        : true,
    name             : '',
    order            : 1,
    alt_text         : '',
    image_url        : '',
    mobile_image_url : '',
    header_text      : '',
    caption_text     : '',
    title_text       : '',
    seo_title        : '',
    url              : ''
  },
  image            : new Blob(),
  mobileImage      : new Blob(),
  setImage         : () => {},
  setMobileImage   : () => {},
  handleSubmitForm : () => {}
}

const CmsLuxurySectionEditForm = ({
  section,
  image,
  mobileImage,
  setImage,
  setMobileImage,
  handleSubmitForm
}) => (
  <Formik
    enableReinitialize={ true }
    initialValues={ section }
    validationSchema={ cmsLuxurySectionEditScheme }
    onSubmit={ handleSubmitForm }
  >
    {
      (formik) => (
        <Form>
          <InputField
            type='select'
            name='is_active'
            label="Is Active?"
            required={ true }
          >
            <option value={ true }> { 'YES' } </option>
            <option value={ false }> { 'NO' } </option>
          </InputField>
          <InputField
            name='name'
            label='Name'
            type='text'
            required={ true }
          />
          <InputField
            name='order'
            label='Order'
            type='number'
            min={ 1 }
            max={ 10 }
            required={ true }
          />
          <InputField
            name='alt_text'
            label='Alt Text'
            type='text'
            required={ true }
          />
          <InputField
            name='seo_title'
            label='SEO Title'
            type='text'
          />
          <InputField
            name='header_text'
            label='Header Text'
            type='text'
          />
          <InputField
            name='title_text'
            label='Title Text'
            type='text'
          />
          <InputField
            name='caption_text'
            label='Caption Text'
            type='text'
          />
          <InputGroupField
            name='url'
            label='Url'
            inputGroupText='https://www.tinkerlust.com'
            type='text'
            addonType='prepend'
          />
          <UploadImageField
            id='section-image'
            label='Image'
            image={ image }
            required={ true }
            initialImageSrc={ formik.values.image_url }
            setValue={ (input) => {
              setImage(input)
            } }
          />
          <UploadImageField
            id='section-mobile-image'
            label='Mobile Image'
            image={ mobileImage }
            required={ true }
            initialImageSrc={ formik.values.mobile_image_url }
            setValue={ (input) => {
              setMobileImage(input)
            } }
          />
          <LoaderButton
            className='w-100'
            isLoading={ formik.isSubmitting }
            block={ false }
            color='primary'
            onClick={ formik.submitForm }
            text="UPDATE"
          />
        </Form>
      )
    }
  </Formik>
)

CmsLuxurySectionEditForm.propTypes    = propTypes
CmsLuxurySectionEditForm.defaultProps = defaultProps

export default CmsLuxurySectionEditForm
